export default {
  row: 11,
  column: 7,
  topFieldRow: 3,
  initialColumn: 2,
  initialFirstRow: 1,
  initialSecondRow: 0,
};
